<template>
  <PPage :title="$t('sidebar.administracion')" icon="IconAdministration">
    <POptionBarNew v-model="optionSelected" :options="options" class="option-bar">
      <template #clientes>
        <AdminClientesComponent
          v-if="columnsConfigCliente"
          :columnsConfigCliente="columnsConfigCliente"
        />
      </template>
      <template #usuarios>
        <AdminUsuariosComponent
          v-if="columnsConfigUsuario"
          :columnsConfigUsuario="columnsConfigUsuario"
        />
      </template>
      <template #paises> <AdminPaisesComponent /> </template>
      <template #columnas> <AdminColumnasComponent /> </template>
      <template #cargas>
        <AdminCargasComponent v-if="columnsConfigCarga" :columnsConfigCarga="columnsConfigCarga" />
      </template>
    </POptionBarNew>
  </PPage>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import POptionBarNew from "@/components/look/POptionBarNew/POptionBarNew.vue";
import AdminClientesComponent from "@/components/administracion/clientes/AdminClientesComponent.vue";
import AdminUsuariosComponent from "@/components/administracion/usuarios/AdminUsuariosComponent.vue";
import AdminColumnasComponent from "@/components/administracion/columnas/AdminColumnasComponent.vue";
import AdminCargasComponent from "@/components/administracion/cargas/AdminCargasComponent.vue";
import AdminPaisesComponent from "@/components/administracion/paises/AdminPaisesComponent.vue";
import { IOptionBarItem, PPage } from "@/components/look";
import { Action } from "vuex-class";
import { IColumnaResponse } from "@/services";

@Component({
  components: {
    PPage,
    POptionBarNew,
    AdminClientesComponent,
    AdminUsuariosComponent,
    AdminPaisesComponent,
    AdminColumnasComponent,
    AdminCargasComponent,
  },
})
export default class AdministracionPage extends Vue {
  @Action("fetchColumna")
  fetchColumna!: (codTabla: string) => Promise<IColumnaResponse | undefined>;

  columnsConfigCarga: IColumnaResponse | null = null;
  columnsConfigCliente: IColumnaResponse | null = null;
  columnsConfigUsuario: IColumnaResponse | null = null;

  async created(): Promise<void> {
    const responses = await Promise.all([
      this.fetchColumna("cargas"),
      this.fetchColumna("clientes"),
      this.fetchColumna("usuarios"),
    ]);
    this.columnsConfigCarga = responses[0] || {
      codTabla: "cargas",
      codColumna: "",
      columnas: [],
    };
    this.columnsConfigCliente = responses[1] || {
      codTabla: "clientes",
      codColumna: "",
      columnas: [],
    };
    this.columnsConfigUsuario = responses[2] || {
      codTabla: "usuarios",
      codColumna: "",
      columnas: [],
    };
  }

  get optionSelected(): string {
    return this.$route.name ?? "usuarios";
  }

  set optionSelected(option: string) {
    this.$router.push({ path: `/administracion/${option}` });
  }

  get options(): IOptionBarItem[] {
    return [
      {
        text: this.$t("label.clientes"),
        value: "clientes",
        hidden: !this.$ability.can("read", "AdminClientes"),
      },
      {
        text: this.$t("label.usuarios"),
        value: "usuarios",
        hidden: !this.$ability.can("read", "AdminUsuarios"),
      },
      {
        text: this.$t("label.paises"),
        value: "paises",
        hidden: !this.$ability.can("read", "AdminPaises"),
      },
      {
        text: this.$t("label.columnas"),
        value: "columnas",
        hidden: !this.$ability.can("read", "AdminColumnas"),
      },
      {
        text: this.$t("administracion.cargas.descripcion"),
        value: "cargas",
        hidden: !this.$ability.can("read", "AdminCargas"),
      },
    ];
  }
}
</script>

<style lang="scss" scoped>
.option-bar::v-deep {
  & > .p-option-bar-container {
    padding-top: 0;
  }

  @media (min-width: 681px) {
    & > .p-option-bar-container {
      margin-top: -1em !important;
      padding-bottom: 2rem !important;
    }
  }
}
</style>
